import {
  Cancel01Icon,
  MoneyAdd01Icon,
  MoneyExchange01Icon
} from "@hugeicons-pro/core-stroke-rounded";
import {
  Button,
  ButtonVariant,
  IconButton,
  IconButtonSize,
  Radio
} from "shared/components";
import { Views } from "../types";
import { HugeiconsIcon } from "@hugeicons/react";
import { Card } from "shared/components/Card";
import { cx, has } from "shared/utils";
import { IconSvgObject } from "types/common/icons";

const RadioCard = ({
  icon,
  onClick,
  isChecked,
  title,
  description,
  costCents
}: {
  className?: string;
  isChecked: boolean;
  onClick: () => void;
  icon: IconSvgObject;
  title: string;
  description: string;
  costCents?: number;
}) => {
  const isActive = Boolean(isChecked);

  return (
    <Card
      className={cx(
        "flex justify-between bg-content-1000-inverted rounded-lg border border-alpha-100 transition-all duration-200",
        isActive ? "shadow-sm" : "shadow-xs"
      )}
      onClick={onClick}
    >
      <div className="flex gap-3 p-5">
        <Radio
          id={title}
          name="rerun-modal-option"
          checked={isChecked}
          className="block mt-1"
        />
        <div className="">
          <h1 className="font-bold mb-1">{title}</h1>
          <p className="text-content-400 text-[13px]">{description}</p>
          <hr className="text-alpha-40 my-3" />
          <p className="text-sm font-medium">
            Verification cost
            {has(costCents) && (
              <span className="ml-2 py-0.5 px-2 bg-alpha-40 rounded-full text-content-700 text-[13px]">
                ${(costCents / 100).toFixed(2)}
              </span>
            )}
          </p>
        </div>
      </div>

      <div
        className={cx(
          "flex items-center justify-center min-w-24 rounded-r-lg",
          isChecked ? "bg-primary-20" : "bg-alpha-40"
        )}
      >
        <HugeiconsIcon
          icon={icon}
          size={40}
          className={cx(isChecked ? "text-primary-500" : "text-content-100")}
        />
      </div>
    </Card>
  );
};

export const SelectOptionView = ({
  onClose,
  costCents,
  onContinue,
  selectedOption,
  setSelectedOption
}: {
  onClose: () => void;
  costCents?: number;
  onContinue: () => void;
  selectedOption: Views;
  setSelectedOption: (value: Views) => void;
}) => {
  return (
    <div className="flex flex-col h-full">
      <header className="p-6 border-b border-alpha-100">
        <h1 className="text-xl text-content-1000 font-bold relative">
          Re-run income report
          <IconButton
            HugeIcon={Cancel01Icon}
            size={IconButtonSize.SM}
            borderLess
            className="absolute -top-2 -right-2 text-content-500"
            onClick={onClose}
          />
        </h1>
      </header>

      <div className="flex-grow bg-background-900 p-6 space-y-3">
        <RadioCard
          isChecked={selectedOption === Views.Intro}
          onClick={() => setSelectedOption(Views.Intro)}
          icon={MoneyExchange01Icon}
          title="Run new report"
          description="Boom will send a request to the applicant to fill out the income report from scratch"
          costCents={costCents}
        />

        <RadioCard
          isChecked={selectedOption === Views.AddIncomeSource}
          onClick={() => setSelectedOption(Views.AddIncomeSource)}
          icon={MoneyAdd01Icon}
          title="Add new income source"
          description="A new income source will be added to the existing report"
          costCents={costCents}
        />
      </div>

      <div className="px-6 py-4 border-t border-alpha-100 gap-2 flex justify-end w-full">
        <Button className="w-[125px]" onClick={onClose}>
          Cancel
        </Button>

        <Button
          className="w-[125px]"
          variant={ButtonVariant.PRIMARY}
          onClick={onContinue}
        >
          Continue
        </Button>
      </div>
    </div>
  );
};
